/* ════════════════════════════════════════════════════════════════════
 *  EMPREGARE — SITE INSTITUCIONAL B2B · Diagnóstico de Conformidade NR-1
 *  Compilado pelo webpack → js/build/empresa-v2-diagnostico-nr1.min.js
 *  Carregado SOMENTE na página /business/ferramentas/diagnostico-nr1.
 *  Gêmeo do empresa-v2-diagnostico.js (mesma mecânica Typeform + lead-gate).
 *
 *  Fluxo: intro → q1..q9 → lead → result
 *    q1 porte · q2 exposição · q3 PGR · q4 inventário+plano · q5 psicossocial
 *    q6 canal de escuta · q7 admissão/treinamento · q8 saúde ocupacional
 *    q9 eSocial/auditoria
 *
 *  Responsabilidades:
 *    · Navegação Typeform-style (uma tela por vez) + barra de progresso
 *    · Captura de lead + POST fetch/JSON (persiste + e-mail comercial)
 *    · SCORING dos 5 pilares + Índice de Conformidade (0–100) e faixa
 *    · Estimativa ILUSTRATIVA de risco de autuação (NR-28 / URF 2026)
 *    · Plano de ação priorizado por lacuna (honesto — sem inventar produto)
 *    · RELATÓRIO: gauge, radar Chart.js dos 5 pilares, alerta de prazo,
 *      card de risco, plano de ação, material de apoio + confetti
 *
 *  ⚠️ Todo o cálculo roda no client (cultura pt-BR / regra de decimais em
 *     SVG/Razor). O servidor NÃO recalcula. As libs (Chart.js, confetti)
 *     são carregadas por CDN — o bundle degrada com elegância se ausentes.
 * ════════════════════════════════════════════════════════════════════ */

(function () {
    'use strict';

    function ready(fn) {
        if (document.readyState !== 'loading') { fn(); }
        else { document.addEventListener('DOMContentLoaded', fn); }
    }

    ready(function () {
        var quiz = document.querySelector('[data-dx-quiz]');
        if (!quiz) return;

        var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        var resultActionUrl = quiz.getAttribute('data-result-action') || '#';
        var enviarUrl = quiz.getAttribute('data-dx-enviar') || '';

        // ── Sequência de telas ─────────────────────────────────────────
        var ORDER = ['intro', 'q1', 'q2', 'q3', 'q4', 'q5', 'q6', 'q7', 'q8', 'q9', 'lead', 'result'];
        var PROGRESS_STEPS = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6', 'q7', 'q8', 'q9', 'lead'];

        var steps = {};
        ORDER.forEach(function (id) {
            steps[id] = quiz.querySelector('[data-dx-step="' + id + '"]');
        });

        // ── Estado das respostas (todas de ESCOLHA, chaves curtas) ─────
        var answers = {
            porte: null,             // q1 — mei | ate19 | 20a99 | 100a499 | 500mais
            exposicao: null,         // q2 — administrativo | operacional | naosei
            pgr: null,               // q3 — atualizado | desatualizado | nao | naosei
            inventarioPlano: null,   // q4 — ambos | um | nao | naosei
            psicossocial: null,      // q5 — estruturado | iniciando | nao | naosei
            canalEscuta: null,       // q6 — sim | parcial | nao
            admissao: null,          // q7 — digital | informal | nao
            saudeOcupacional: null,  // q8 — sim | parcial | nao | naosei
            esocial: null            // q9 — sim | parcial | nao | naosei
        };

        var currentId = 'intro';

        // ── Barra de progresso (no layout _LayoutDiagnostico) ──────────
        var progressEl = document.querySelector('[data-dx-progress]');
        var progressFill = document.querySelector('[data-dx-progress-fill]');

        function setProgress(id) {
            var idx = PROGRESS_STEPS.indexOf(id);
            var pct;
            if (id === 'intro') pct = 0;
            else if (id === 'result') pct = 100;
            else pct = Math.round(((idx + 1) / PROGRESS_STEPS.length) * 100);
            if (progressFill) progressFill.style.width = pct + '%';
            if (progressEl) progressEl.setAttribute('aria-valuenow', String(pct));
        }

        // ── Troca de tela ───────────────────────────────────────────────
        function show(id) {
            if (!steps[id]) return;
            Object.keys(steps).forEach(function (key) {
                var el = steps[key];
                if (!el) return;
                var on = key === id;
                el.classList.toggle('is-active', on);
                el.hidden = !on;
            });
            currentId = id;
            setProgress(id);

            var heading = steps[id].querySelector('h1, h2, [tabindex="-1"]');
            if (heading) {
                if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
                try { heading.focus({ preventScroll: false }); } catch (e) { heading.focus(); }
            }
            window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
        }

        function go(direction) {
            var idx = ORDER.indexOf(currentId);
            var nextIdx = idx + direction;
            if (nextIdx < 0 || nextIdx >= ORDER.length) return;
            show(ORDER[nextIdx]);
        }

        function isStepAnswered(id) {
            var step = steps[id];
            if (!step) return true;
            var key = step.getAttribute('data-dx-key');
            return answers[key] !== null;
        }

        // ── INTRO: botão começar ────────────────────────────────────────
        var startBtn = quiz.querySelector('[data-dx-start]');
        if (startBtn) startBtn.addEventListener('click', function () { show('q1'); });

        // ── Botões "Voltar" ─────────────────────────────────────────────
        quiz.querySelectorAll('[data-dx-back]').forEach(function (btn) {
            btn.addEventListener('click', function () { go(-1); });
        });

        // ── Perguntas de ESCOLHA (todas as 9) ───────────────────────────
        // Selecionar avança automaticamente (fluidez Typeform).
        quiz.querySelectorAll('[data-dx-step][data-dx-kind="choice"]').forEach(function (step) {
            var key = step.getAttribute('data-dx-key');
            var choices = Array.prototype.slice.call(step.querySelectorAll('[data-dx-choice]'));

            function select(btn) {
                choices.forEach(function (c) {
                    var on = c === btn;
                    c.classList.toggle('is-selected', on);
                    c.setAttribute('aria-checked', String(on));
                });
                answers[key] = btn.getAttribute('data-dx-value');
                window.setTimeout(function () { go(1); }, prefersReducedMotion ? 0 : 260);
            }

            choices.forEach(function (btn) {
                btn.addEventListener('click', function () { select(btn); });
            });
        });

        // ════════════════════════════════════════════════════════════════
        //  SCORING — fonte única do cálculo (client-side)
        // ════════════════════════════════════════════════════════════════

        // Notas de resposta → pontos (0–100) por pergunta.
        var PONTOS = {
            pgr:          { atualizado: 100, desatualizado: 50, nao: 0, naosei: 15 },
            inventario:   { ambos: 100, um: 50, nao: 0, naosei: 15 },
            psicossocial: { estruturado: 100, iniciando: 45, nao: 0, naosei: 15 },
            canal:        { sim: 100, parcial: 50, nao: 0 },
            admissao:     { digital: 100, informal: 45, nao: 0 },
            saude:        { sim: 100, parcial: 50, nao: 0, naosei: 15 },
            esocial:      { sim: 100, parcial: 50, nao: 0, naosei: 15 }
        };

        function pts(tabela, valor) {
            var t = PONTOS[tabela];
            var v = (t && typeof t[valor] === 'number') ? t[valor] : 0;
            return v;
        }

        // MEI dispensado de PGR? (dispensado se q1=mei E q2 != operacional)
        function meiDispensado() {
            return answers.porte === 'mei' && answers.exposicao !== 'operacional';
        }

        // Pilares (0–100)
        function pilares() {
            var groRaw = Math.round((pts('pgr', answers.pgr) + pts('inventario', answers.inventarioPlano)) / 2);
            var groPgr = meiDispensado() ? Math.max(groRaw, 60) : groRaw; // MEI é dispensado — não punir
            var psico = Math.round((pts('psicossocial', answers.psicossocial) + pts('canal', answers.canalEscuta)) / 2);
            var admissao = pts('admissao', answers.admissao);
            var saude = pts('saude', answers.saudeOcupacional);
            var esocial = pts('esocial', answers.esocial);
            return { groPgr: groPgr, psico: psico, admissao: admissao, saude: saude, esocial: esocial };
        }

        function indice(p) {
            return Math.round(0.25 * p.groPgr + 0.25 * p.psico + 0.20 * p.admissao + 0.15 * p.saude + 0.15 * p.esocial);
        }

        // Faixa (rótulo + chave de cor)
        function faixaFor(idx) {
            if (idx >= 90) return { nome: 'Preparada', key: 'ok', desc: 'Sua empresa está bem posicionada frente à NR-1. Mantenha as revisões e a documentação sempre localizáveis para a fiscalização.' };
            if (idx >= 71) return { nome: 'Bem encaminhada', key: 'good', desc: 'Você já cobre boa parte da NR-1. Feche as lacunas apontadas abaixo para chegar à conformidade plena, com atenção especial ao prazo dos riscos psicossociais.' };
            if (idx >= 41) return { nome: 'Parcialmente adequada', key: 'warn', desc: 'Há pilares importantes em aberto. Priorize o plano de ação abaixo — em especial o gerenciamento dos riscos psicossociais, cuja fiscalização começa em 26/05/2026.' };
            return { nome: 'Exposta', key: 'risk', desc: 'Sua empresa está exposta a autuação em vários pilares da NR-1. O plano de ação abaixo mostra por onde começar, do mais urgente ao complementar.' };
        }

        // ── Risco de multa (estimativa ILUSTRATIVA NR-28 / URF 2026) ────
        var BASE_MULTA = { mei: 900, ate19: 1500, '20a99': 3000, '100a499': 6000, '500mais': 12000 };

        function riscoMulta() {
            var base = BASE_MULTA[answers.porte] || 1500;
            var fator = 0;

            // parcela de PGR só conta se a empresa NÃO for MEI dispensado de PGR
            if (!meiDispensado()) {
                if (answers.pgr === 'nao' || answers.pgr === 'desatualizado' || answers.pgr === 'naosei') fator += 1;
            }
            if (answers.psicossocial === 'nao' || answers.psicossocial === 'naosei') fator += 1;
            if (answers.esocial === 'nao' || answers.esocial === 'parcial' || answers.esocial === 'naosei') fator += 0.5;

            return Math.round(base * fator);
        }

        // ── Plano de ação priorizado por lacuna (honesto) ───────────────
        function recommendations() {
            var recs = [];

            // 1) GRO/PGR
            if (answers.pgr !== 'atualizado') {
                if (meiDispensado()) {
                    recs.push({ ic: 'bi-clipboard-check', pri: 'media', txt: 'Como <b>MEI você é dispensado do PGR</b> — preencha as <b>Fichas de Gerenciamento de Riscos</b> do MTE para registrar os riscos da sua atividade.' });
                } else {
                    recs.push({ ic: 'bi-clipboard-check', pri: 'alta', txt: 'Elabore/atualize o <b>PGR</b> (Inventário de Riscos + Plano de Ação); a revisão deve acontecer no máximo a cada 2 anos.' });
                }
            }
            // 2) Inventário + Plano
            if (answers.inventarioPlano !== 'ambos' && !meiDispensado()) {
                recs.push({ ic: 'bi-journal-text', pri: 'alta', txt: 'Documente os <b>dois pilares do PGR</b>: o Inventário de Riscos e o Plano de Ação.' });
            }
            // 3) Psicossocial — SEMPRE com o alerta de prazo
            if (answers.psicossocial !== 'estruturado') {
                recs.push({ ic: 'bi-people', pri: 'urgente', txt: '<span class="nr-reco__flag"><i class="bi bi-exclamation-triangle-fill"></i></span> Inclua os <b>fatores de risco psicossocial</b> no PGR até <b>26/05/2026</b> (assédio, sobrecarga, metas, jornada, autonomia). Use um instrumento validado, como o COPSOQ.' });
            }
            // 4) Canal de escuta
            if (answers.canalEscuta !== 'sim') {
                recs.push({ ic: 'bi-chat-heart', pri: 'media', txt: 'Crie um <b>canal de escuta/denúncia confidencial</b> e monitore turnover, absenteísmo e afastamentos por saúde mental.' });
            }
            // 5) Admissão & Treinamento — PONTE HONESTA COM O PRODUTO
            if (answers.admissao !== 'digital') {
                recs.push({ ic: 'bi-file-earmark-check-fill', pri: 'alta', txt: 'Digitalize a <b>integração/treinamento de segurança</b> na admissão, com registro auditável de ciência dos riscos ANTES do início. <b>É aqui que a Empregare entra:</b> a admissão digital centraliza documentos, treinamento admissional e assinatura, com trilha auditável para o eSocial.' });
            }
            // 6) Saúde ocupacional
            if (answers.saudeOcupacional !== 'sim') {
                recs.push({ ic: 'bi-heart-pulse', pri: 'media', txt: 'Mantenha <b>ASO admissional/periódico e PCMSO</b> em dia, integrados ao PGR.' });
            }
            // 7) eSocial & Auditoria — ponte leve com o produto
            if (answers.esocial !== 'sim') {
                recs.push({ ic: 'bi-shield-check', pri: 'alta', txt: 'Regularize os <b>eventos de SST no eSocial</b> e garanta consistência com PGR/laudos; organize a documentação para localizar tudo numa fiscalização.' });
            }

            if (recs.length === 0) {
                recs.push({ ic: 'bi-check2-circle', pri: 'ok', txt: 'Seus pilares da NR-1 estão bem cobertos. Mantenha as <b>revisões periódicas</b> (PGR a cada 2 anos) e a documentação sempre localizável para a fiscalização.' });
            }

            return recs;
        }

        // Texto puro do plano de ação (p/ persistir + e-mail)
        function recommendationsPlainText() {
            return recommendations().map(function (r) {
                return '• ' + (r.txt || '').replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
            }).join('\n');
        }

        // ════════════════════════════════════════════════════════════════
        //  LEAD-GATE — validação client-side + POST fetch/JSON
        // ════════════════════════════════════════════════════════════════
        var leadForm = quiz.querySelector('[data-dx-lead-form]');

        function fieldValid(input) {
            var v = (input.value || '').trim();
            if (!v) return false;
            var type = input.getAttribute('data-dx-type');
            if (type === 'email') return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
            if (type === 'tel') return (v.replace(/\D/g, '').length >= 10);
            if (type === 'fullname') return v.split(/\s+/).length >= 2;
            return v.length >= 2;
        }

        function validateLead() {
            var fields = Array.prototype.slice.call(leadForm.querySelectorAll('[data-dx-lead]'));
            var firstInvalid = null;
            fields.forEach(function (input) {
                var ok = fieldValid(input);
                var field = input.closest('.dx-field');
                if (field) field.classList.toggle('has-error', !ok);
                // aria-invalid só existe enquanto há erro: deixar "false" pendurado faz o
                // leitor de tela anunciar "inválido" corrigido em campo nunca validado.
                if (ok) input.removeAttribute('aria-invalid');
                else input.setAttribute('aria-invalid', 'true');
                if (!ok && !firstInvalid) firstInvalid = input;
            });
            // as caixas de erro não são live region: seriam 4 anúncios se atropelando num submit vazio.
            // Quem avisa é o foco no primeiro campo inválido, que faz o leitor ler o aria-describedby.
            if (firstInvalid) { firstInvalid.focus(); return false; }
            return true;
        }

        if (leadForm) {
            // máscara de telefone (BR) — mesma lógica da AgendDemo/Diagnóstico
            var telEl = leadForm.querySelector('#dx-telefone');
            if (telEl) {
                telEl.setAttribute('inputmode', 'tel');
                telEl.setAttribute('maxlength', '15');
                telEl.addEventListener('input', function () {
                    var d = telEl.value.replace(/\D/g, '').slice(0, 11);
                    var out = d;
                    if (d.length > 2 && d.length <= 6) out = '(' + d.slice(0, 2) + ') ' + d.slice(2);
                    else if (d.length > 6 && d.length <= 10) out = '(' + d.slice(0, 2) + ') ' + d.slice(2, 6) + '-' + d.slice(6);
                    else if (d.length > 10) out = '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
                    telEl.value = out;
                });
            }

            leadForm.querySelectorAll('[data-dx-lead]').forEach(function (input) {
                input.addEventListener('input', function () {
                    var field = input.closest('.dx-field');
                    if (field && field.classList.contains('has-error') && fieldValid(input)) {
                        field.classList.remove('has-error');
                        input.removeAttribute('aria-invalid');
                    }
                });
            });

            leadForm.addEventListener('submit', function (e) {
                e.preventDefault();
                if (!validateLead()) return;

                var nome = (leadForm.querySelector('#dx-nome') || {}).value || '';
                var empresa = (leadForm.querySelector('#dx-empresa') || {}).value || '';
                try {
                    window.sessionStorage.setItem('dxNr1Nome', nome.trim());
                    window.sessionStorage.setItem('dxNr1Empresa', empresa.trim());
                } catch (err) {}

                enviarLead();       // POST (não bloqueia o relatório)
                computeAndRender();
                show('result');
                celebrate();
            });
        }

        function buildLeadPayload() {
            var p = pilares();
            var idx = indice(p);
            var faixa = faixaFor(idx);

            function num(id) { var el = leadForm.querySelector(id); return el ? (el.value || '').trim() : ''; }

            return {
                // lead
                Nome: num('#dx-nome'),
                Email: num('#dx-email'),
                Telefone: num('#dx-telefone'),
                Empresa: num('#dx-empresa'),
                // respostas cruas (q1..q9)
                Porte: answers.porte,
                Exposicao: answers.exposicao,
                Pgr: answers.pgr,
                InventarioPlano: answers.inventarioPlano,
                Psicossocial: answers.psicossocial,
                CanalEscuta: answers.canalEscuta,
                Admissao: answers.admissao,
                SaudeOcupacional: answers.saudeOcupacional,
                Esocial: answers.esocial,
                // resultado calculado (fonte única = este JS)
                IndiceConformidade: idx,
                FaixaConformidade: faixa.nome,
                NotaGroPgr: p.groPgr,
                NotaPsicossocial: p.psico,
                NotaAdmissao: p.admissao,
                NotaSaude: p.saude,
                NotaEsocial: p.esocial,
                RiscoMulta: riscoMulta(),
                PlanoAcao: recommendationsPlainText()
            };
        }

        function enviarLead() {
            if (!enviarUrl || !window.fetch) return;
            var submitBtn = leadForm.querySelector('.dx-lead__submit');
            if (submitBtn) { submitBtn.disabled = true; }

            var payload;
            try { payload = buildLeadPayload(); }
            catch (err) { if (submitBtn) submitBtn.disabled = false; return; }

            fetch(enviarUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify(payload)
            }).then(function (res) {
                return res.text().then(function (t) {
                    var d = {}; try { d = t ? JSON.parse(t) : {}; } catch (_) {}
                    return { ok: res.ok, data: d };
                });
            }).then(function (r) {
                if (!r.ok || (r.data && r.data.ok === false)) {
                    console.error('[Empregare][DiagnosticoNr1] falha ao registrar o lead', r.data);
                }
            }).catch(function (err) {
                console.error('[Empregare][DiagnosticoNr1] erro de rede ao registrar o lead', err);
            }).then(function () {
                if (submitBtn) submitBtn.disabled = false;
            });
        }

        // ── Formatação pt-BR ────────────────────────────────────────────
        function fmtMoney(v) { return 'R$ ' + Math.round(v).toLocaleString('pt-BR'); }

        function setText(sel, txt) { var el = quiz.querySelector(sel); if (el) el.textContent = txt; }
        function setHTML(sel, html) { var el = quiz.querySelector(sel); if (el) el.innerHTML = html; }

        // ── Confetti (degrada se a lib não carregou) ────────────────────
        function celebrate() {
            if (prefersReducedMotion || typeof window.confetti !== 'function') return;
            try {
                window.confetti({ particleCount: 90, spread: 70, origin: { y: 0.35 }, disableForReducedMotion: true });
                window.setTimeout(function () {
                    window.confetti({ particleCount: 50, angle: 60, spread: 60, origin: { x: 0 } });
                    window.confetti({ particleCount: 50, angle: 120, spread: 60, origin: { x: 1 } });
                }, 220);
            } catch (e) {}
        }

        // ── Radar Chart.js dos 5 pilares (degrada p/ barras se ausente) ─
        var radarChart = null;
        function renderRadar(p) {
            var canvas = quiz.querySelector('[data-dx-radar]');
            var fallback = quiz.querySelector('[data-dx-radar-fallback]');
            if (!canvas) return;

            if (typeof window.Chart === 'undefined') {
                // sem a lib → mostra as barras de fallback (sempre presentes no HTML)
                canvas.style.display = 'none';
                if (fallback) fallback.hidden = false;
                return;
            }
            if (fallback) fallback.hidden = true;
            canvas.style.display = 'block';

            var labels = ['GRO/PGR', 'Riscos\nPsicossociais', 'Admissão &\nTreinamento', 'Saúde\nOcupacional', 'eSocial &\nAuditoria'];
            var data = [p.groPgr, p.psico, p.admissao, p.saude, p.esocial];

            if (radarChart) { radarChart.destroy(); radarChart = null; }
            try {
                radarChart = new window.Chart(canvas.getContext('2d'), {
                    type: 'radar',
                    data: {
                        labels: labels,
                        datasets: [{
                            label: 'Conformidade por pilar',
                            data: data,
                            fill: true,
                            backgroundColor: 'rgba(63, 63, 216, 0.14)',
                            borderColor: 'rgba(63, 63, 216, 0.85)',
                            borderWidth: 2,
                            pointBackgroundColor: '#3F3FD8',
                            pointBorderColor: '#fff',
                            pointRadius: 4,
                            pointHoverRadius: 5
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        animation: prefersReducedMotion ? false : { duration: 900 },
                        plugins: { legend: { display: false }, tooltip: { callbacks: { label: function (c) { return c.formattedValue + '/100'; } } } },
                        scales: {
                            r: {
                                min: 0, max: 100,
                                ticks: { stepSize: 25, backdropColor: 'transparent', color: '#626279', font: { size: 10 } },
                                grid: { color: 'rgba(28, 28, 43, 0.10)' },
                                angleLines: { color: 'rgba(28, 28, 43, 0.10)' },
                                pointLabels: { color: '#1C1C2B', font: { family: "'Plus Jakarta Sans', sans-serif", size: 12, weight: '700' } }
                            }
                        }
                    }
                });
            } catch (e) {
                canvas.style.display = 'none';
                if (fallback) fallback.hidden = false;
            }
        }

        // ── Barras de fallback (pilares) — sempre preenchidas ───────────
        function renderPilarBars(p) {
            var map = {
                groPgr: p.groPgr, psico: p.psico, admissao: p.admissao, saude: p.saude, esocial: p.esocial
            };
            Object.keys(map).forEach(function (key) {
                var val = map[key];
                var valEl = quiz.querySelector('[data-dx-pilar-val="' + key + '"]');
                var barEl = quiz.querySelector('[data-dx-pilar-bar="' + key + '"]');
                if (valEl) valEl.textContent = val + '/100';
                if (barEl) {
                    barEl.setAttribute('data-tier', val >= 71 ? 'good' : (val >= 41 ? 'warn' : 'risk'));
                    if (prefersReducedMotion) { barEl.style.width = val + '%'; }
                    else { barEl.style.width = '0%'; void barEl.getBoundingClientRect(); barEl.style.width = val + '%'; }
                }
            });
        }

        // ── Count-up (clonado do Diagnóstico) ───────────────────────────
        function countUp(el, target) {
            if (!el) return;
            if (prefersReducedMotion) { el.textContent = String(target); return; }
            var startTs = null, dur = 1200;
            (function tick(ts) {
                if (!startTs) startTs = ts;
                var pr = Math.min((ts - startTs) / dur, 1);
                var eased = 1 - Math.pow(1 - pr, 3);
                el.textContent = String(Math.round(target * eased));
                if (pr < 1) window.requestAnimationFrame(tick);
            })(performance.now ? performance.now() : 0);
        }

        // ── Render do relatório ─────────────────────────────────────────
        function computeAndRender() {
            var p = pilares();
            var idx = indice(p);
            var faixa = faixaFor(idx);
            var risco = riscoMulta();

            var nome = '', empresa = '';
            try {
                nome = (window.sessionStorage.getItem('dxNr1Nome') || '').split(' ')[0];
                empresa = window.sessionStorage.getItem('dxNr1Empresa') || '';
            } catch (e) {}

            // cabeçalho
            setText('[data-dx-result-greet]', empresa ? ('Diagnóstico NR-1 · ' + empresa) : 'Seu diagnóstico de conformidade');
            setHTML('[data-dx-result-headline]',
                (nome ? (nome + ', ') : '') + 'sua conformidade com a NR-1 é <span class="dx-pop">' + faixa.nome + '</span>.');
            setText('[data-dx-result-sub]', faixa.desc);

            // gauge do Índice de Conformidade
            var gaugeWrap = quiz.querySelector('[data-dx-gauge]');
            if (gaugeWrap) gaugeWrap.setAttribute('data-tier', faixa.key);
            setText('[data-dx-faixa]', faixa.nome);

            var ring = quiz.querySelector('[data-dx-score-ring]');
            var numEl = quiz.querySelector('[data-dx-score-num]');
            var CIRC = 540; // ~ 2π·86
            var offset = CIRC - (idx / 100) * CIRC;
            if (prefersReducedMotion) {
                if (ring) ring.style.strokeDashoffset = String(offset);
            } else if (ring) {
                ring.style.transition = 'stroke-dashoffset 1.2s cubic-bezier(.4,0,.2,1)';
                void ring.getBoundingClientRect();
                ring.style.strokeDashoffset = String(offset);
            }
            countUp(numEl, idx);

            // radar + barras de pilares (barras servem de fallback e sempre renderizam)
            renderPilarBars(p);
            renderRadar(p);

            // card de risco (estimativa ilustrativa)
            var riskWrap = quiz.querySelector('[data-dx-risk]');
            if (risco > 0) {
                setText('[data-dx-risk-num]', fmtMoney(risco));
                if (riskWrap) riskWrap.hidden = false;
            } else if (riskWrap) {
                riskWrap.hidden = true;
            }

            // plano de ação
            var list = quiz.querySelector('[data-dx-reco-list]');
            if (list) {
                list.innerHTML = '';
                recommendations().forEach(function (rec) {
                    var li = document.createElement('li');
                    li.className = 'nr-reco__item';
                    li.setAttribute('data-pri', rec.pri || '');
                    li.innerHTML =
                        '<span class="nr-reco__ic"><i class="bi ' + rec.ic + '"></i></span>' +
                        '<span class="nr-reco__txt">' + rec.txt + '</span>';
                    list.appendChild(li);
                });
            }

            // CTA aponta para AgendDemo
            var cta = quiz.querySelector('[data-dx-result-cta]');
            if (cta && resultActionUrl && resultActionUrl !== '#') cta.setAttribute('href', resultActionUrl);
        }

        // ── Refazer diagnóstico ─────────────────────────────────────────
        var restartBtn = quiz.querySelector('[data-dx-restart]');
        if (restartBtn) {
            restartBtn.addEventListener('click', function () {
                Object.keys(answers).forEach(function (k) { answers[k] = null; });
                quiz.querySelectorAll('[data-dx-choice].is-selected').forEach(function (c) {
                    c.classList.remove('is-selected');
                    c.setAttribute('aria-checked', 'false');
                });
                show('intro');
            });
        }

        // ── Inicialização ───────────────────────────────────────────────
        setProgress('intro');
    });
})();
